module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/4_3553045adbdf35d61ac4c142d3b97df4.png";